import { Component, inject } from '@angular/core';
import { SettingsService } from '../../shared/settings/settings.service';
import { ViewModelProperty, SettingsFormComponent } from '@lfw/roesberg';
import { LfwRouterService } from '../../route/lfw-router.service';

@Component({
  selector: 'lfw-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css'],
  imports: [SettingsFormComponent]
})
export class SettingsPageComponent {
  settings: Array<Array<ViewModelProperty>>;

  private settingsService = inject(SettingsService);
  private routerService = inject(LfwRouterService);

  constructor() {
    this.settings = this.settingsService.settings.visibleSettings;
  }

  goToChangePassword() {
    this.routerService.navigateToPasswordChange();
  }
}
